import React, { useState, useEffect } from "react";
import stores from "../../data/store";
import SearchByList from "./SearchByList";
import { BsSearch } from "react-icons/bs";
import { BiCurrentLocation } from "react-icons/bi";

function SearchStore({ onNearestStores }) {
  const [userLocation, setUserLocation] = useState("");
  const [nearestStores, setNearestStores] = useState([]);
  const [userCoordinates, setUserCoordinates] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [resultMessage, setResultMessage] = useState(false);
  useEffect(() => {
    const inputElement = document.getElementById("autocomplete-input");
    //change for uk only
    const options = {
      types: ["(cities)"],
      componentRestrictions: { country: "uk" },
    };
    // console.log("This is inputElement" + inputElement);
    // if (inputElement) {
    //   setNearestStores([]);
    //   const autoComplete = new window.google.maps.places.Autocomplete(
    //     inputElement,
    //     options
    //   );
    //   autoComplete.addListener("place_changed", () => {
    //     const place = autoComplete.getPlace();
    //     if (place && place.formatted_address) {
    //       handleUserLocationInput(place.formatted_address);
    //     }
    //   });

    //   setAutocomplete(autoComplete);
    // }
  }, []);

  const calculateDistanceInMiles = (location1, location2) => {
    const lat1 = location1.lat;
    const lon1 = location1.lng;
    const lat2 = location2.lat;
    const lon2 = location2.lng;

    const R = 6371; // Radius of the Earth in kilometers.
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distanceInKilometers = R * c;

    const distanceInMiles = distanceInKilometers * 0.621371;

    return distanceInMiles;
  };
  const handleUserLocationInput = async (location) => {
    // console.log("this is handle function" + location);
    setIsLoading(true);
    setNearestStores([]);
    setResultMessage(false);
    onNearestStores([]);
    let storesWithinRadius = [];
    try {
      // const timestamp = new Date().getTime();

      const geoLocationResponse = await fetch(
        `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&q=${encodeURIComponent(
          location
        )}`
      );
      if (!geoLocationResponse.ok) {
        throw new Error("Geocoding requested failed");
      }
      const geoCodingData = await geoLocationResponse.json();
      if (!geoCodingData.length) {
        throw new Error("Gecoding respond not Okay");
      }
      const userCoordinate = {
        lat: parseFloat(geoCodingData[0].lat),
        lng: parseFloat(geoCodingData[0].lon),
      };
      if (!userCoordinate.lat || !userCoordinate.lng) {
        throw new Error("Invalid address or location not found.");
      }
      const nearestArea = geoCodingData[0].display_name;
      setUserLocation(nearestArea);
      setUserCoordinates(userCoordinate);
      if (userCoordinate) {
        storesWithinRadius = stores.reduce((acu, store) => {
          const distance = calculateDistanceInMiles(userCoordinate, {
            lat: store.lat,
            lng: store.lng,
          });
          if (distance <= 5) {
            acu.push({
              ...store,
              distance,
            });
          }
          return acu;
        }, []);
        storesWithinRadius.sort((a, b) => a.distance - b.distance);
        setNearestStores(storesWithinRadius);
        onNearestStores(storesWithinRadius);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
    if (storesWithinRadius.length === 0) {
      setResultMessage(true);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // Trim any leading/trailing whitespace
      let location = userLocation;
      if (location !== "") {
        setUserLocation(location);
        handleUserLocationInput(location);
      }
    }
  };

  const getUserLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const newLocation = `${latitude}, ${longitude}`;
        handleUserLocationInput(newLocation);
        setUserLocation(newLocation);
      });
    }
  };
  return (
    <div className="searchcontainer">
      <h1>FIND YOUR NEAREST ASIA VILLA</h1>
      <div className="searchsticky">
        <input
          type="text"
          placeholder="Plese Enter Your Place"
          id="autocomplete-input"
          value={userLocation}
          onChange={(e) => setUserLocation(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          className="buttonsearch"
          onClick={() => {
            if (userLocation !== undefined) {
              handleUserLocationInput(userLocation);
            }
          }}
        >
          {/* 🔍 */}
          <BsSearch />
        </button>

        <button onClick={getUserLocation}>
          <BiCurrentLocation />
        </button>
      </div>
      {isLoading && <p>Loading...</p>}
      <SearchByList
        nearestStores={nearestStores}
        resultMessage={resultMessage}
        userLocation={userLocation}
        userCoordinate={userCoordinates}
      />
    </div>
  );
}

export default SearchStore;
